// extracted by mini-css-extract-plugin
module.exports = {"container":"ic","title":"id"};